const tryNewDataPush = () => {
  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      event: {
        name: "click",
        category: "button",
        label: "live-online|beta",
        action: "navigate",
        section: "sales-card",
      },
    });
  }
};

export default tryNewDataPush;

